export enum APIType {
  JSON = 1,
  PB = 2
}
